import { Box } from '@wix/design-system'
import React, { FC } from 'react'

import s from './HeadlessBackground.scss'

interface HeadlessBackgroundProps {
  dataHook?: string
}

export const HeadlessBackground: FC<HeadlessBackgroundProps> = ({ dataHook, children }) => {
  return (
    <Box className={s.page} dataHook={dataHook}>
      {children}
    </Box>
  )
}
